// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, setBookMarkJobByProfessional, tryAgainPaymentForServiceAreaSubscription } from "../../Utils/Constants";
import { showToast } from "../../Helper/Toast";

export const hitTryAgainPaymentForServiceAreaSubscriptionApi = createAsyncThunk("hitTryAgainPaymentForServiceAreaSubscriptionApi", async (token) => {
  try {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
    };
    const url = ApiBaseUrl + tryAgainPaymentForServiceAreaSubscription;
    const response = await axios.put(url, {}, config);
    return response.data;
  } catch (error) {
    showToast(error.response.data.message, "error");
    throw error.response.data;
  }
});

const tryAgainPaymentForServiceAreaSubscriptionSlice = createSlice({
  name: "tryAgainPaymentForServiceAreaSubscriptionReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearTryAgainPaymentForServiceAreaSubscriptionData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitTryAgainPaymentForServiceAreaSubscriptionApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitTryAgainPaymentForServiceAreaSubscriptionApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitTryAgainPaymentForServiceAreaSubscriptionApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearTryAgainPaymentForServiceAreaSubscriptionData } = tryAgainPaymentForServiceAreaSubscriptionSlice.actions;
export default tryAgainPaymentForServiceAreaSubscriptionSlice.reducer;
